import React, { useState } from "react";
import ResetPasswordForm from "../components/core/ResetPasswordForm";
import { app } from "../App";
import { findUserByEmail } from "../utils/firestore";
import { FIREBASE_AUTH_ERROR_MESSAGES } from "../utils/dictionaries";
import { FirebaseError } from "firebase/app";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { resetPasswordFieldsList } from "../components/core/SignUp-SignIn/fieldsLists";

export default function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const [emailSend, setEmailSend] = useState<boolean>(false);
  const [error, setError] = useState<FirebaseError | null>(null);
  const [formData, setFormData] = useState<Record<string, any>>(
    resetPasswordFieldsList.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {}),
  );
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});

  const validateFormData = () => {
    const errors: Record<string, string> = {};
    resetPasswordFieldsList.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "To pole jest wymagane.";
      }
    });
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
    setFormErrors({});
  };

  const handleResetPassword = async () => {
    if (!validateFormData()) return;
    setLoading(true);
    setError(null);

    try {
      // Sprawdź, czy użytkownik z podanym emailem istnieje w bazie danych
      const user = await findUserByEmail(formData.email);
      if (!user) {
        setLoading(false);
        setError({
          code: "auth/user-not-found",
          message: "Nie znaleziono użytkownika z podanym adresem email.",
        } as FirebaseError);
        return;
      }

      // Jeśli użytkownik istnieje, wyślij email z instrukcją resetowania hasła
      await sendPasswordResetEmail(getAuth(app), formData.email);
      setLoading(false);
      setError(null);
      setEmailSend(true);
    } catch (error: any) {
      setLoading(false);
      // Jeśli błąd jest już typu FirebaseError, użyj go bezpośrednio
      if (error.code && error.message) {
        setError(error as FirebaseError);
      } else {
        // W przeciwnym razie utwórz ogólny błąd
        setError({
          code: "auth/internal-error",
          message: "Wystąpił błąd podczas resetowania hasła.",
        } as FirebaseError);
      }
    }
  };

  return (
    <ResetPasswordForm
      formData={formData}
      formErrors={formErrors}
      onChange={handleChange}
      onClick={handleResetPassword}
      loading={loading}
      emailSend={emailSend}
      error={
        error
          ? FIREBASE_AUTH_ERROR_MESSAGES[error.code as keyof typeof FIREBASE_AUTH_ERROR_MESSAGES]
          : undefined
      }
    />
  );
}
